export default __webpack_public_path__ + "static/media/23.18ee1b18.png";